// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    SendExportRegistrantsApiParameter,
    sendExportRegistrantsRequest,
} from "@mcmc/App/Services/ExportRegistrantsService";

type sendExportRegistrantsParameter = {
    courseNumber: string;
} & HasOnSuccess &
    HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<sendExportRegistrantsParameter, SendExportRegistrantsApiParameter, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { courseNumber: props.parameter.courseNumber };
};

export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await sendExportRegistrantsRequest(props.apiParameter);
    } catch (error) {
        props.parameter.onError?.(error.errorMessage);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const sendExportRegistrants = createHandlerChainRunner(chain, "SendExportRegistrants");
export default sendExportRegistrants;
